'use client';

import Image from 'next/image';
import { useRef } from 'react';
import gsap from 'gsap';
import styles from './styles.module.css';

export default function FloatingSection() {
  const plane1 = useRef(null);
  const plane2 = useRef(null);
  const plane3 = useRef(null);
  let requestAnimationFrameId = null;
  let xForce = 0;
  let yForce = 0;
  const easing = 0.08;
  const speed = 0.01;

  const lerp = (start, target, amount) =>
    start * (1 - amount) + target * amount;

  const animate = () => {
    xForce = lerp(xForce, 0, easing);
    yForce = lerp(yForce, 0, easing);
    gsap.set(plane1.current, { x: `+=${xForce}`, y: `+=${yForce}` });
    gsap.set(plane2.current, {
      x: `+=${xForce * 0.5}`,
      y: `+=${yForce * 0.5}`,
    });
    gsap.set(plane3.current, {
      x: `+=${xForce * 0.25}`,
      y: `+=${yForce * 0.25}`,
    });

    if (Math.abs(xForce) < 0.01) xForce = 0;
    if (Math.abs(yForce) < 0.01) yForce = 0;

    if (xForce != 0 || yForce != 0) {
      requestAnimationFrame(animate);
    } else {
      cancelAnimationFrame(requestAnimationFrameId);
      requestAnimationFrameId = null;
    }
  };

  const manageMouseMove = (e) => {
    const { movementX, movementY } = e;
    xForce += movementX * speed;
    yForce += movementY * speed;

    if (requestAnimationFrameId == null) {
      requestAnimationFrameId = requestAnimationFrame(animate);
    }
  };

  return (
    <main
      onMouseMove={(e) => {
        manageMouseMove(e);
      }}
      className={styles.main}
    >
      <div ref={plane1} className={styles.plane}>
        <Image
          src={'/img/avatars/avatar1.png'}
          alt="image"
          width={300}
          height={300}
        />
        <Image
          src={'/img/avatars/avatar2.png'}
          alt="image"
          width={300}
          height={300}
        />
        <Image
          src={'/img/avatars/avatar3.png'}
          alt="image"
          width={225}
          height={225}
        />
      </div>
      <div ref={plane2} className={styles.plane}>
        <Image
          src={'/img/avatars/avatar4.png'}
          alt="image"
          width={250}
          height={250}
        />
        <Image
          src={'/img/avatars/avatar5.png'}
          alt="image"
          width={200}
          height={200}
        />
        <Image
          src={'/img/avatars/avatar6.png'}
          alt="image"
          width={225}
          height={225}
        />
      </div>
      <div ref={plane3} className={`${styles.plane} ${styles.back}`}>
        <Image
          src={'/img/avatars/avatar1.png'}
          alt="image"
          width={150}
          height={150}
        />
        <Image
          src={'/img/avatars/avatar2.png'}
          alt="image"
          width={200}
          height={200}
        />
      </div>
    </main>
  );
}
